import React, { Component } from "react";
import qrCode from "./../../images/qr_code_emec.png";
import logoUnigranrioAfya from "./../../images/Logo_UNI-AFYA_branca2.png";
import "./style.css";
export default class Footer extends Component {
  render() {
    return (
      <footer
        className="site-footer center abs-footer"
        style={this.props.style}
      >
    {/*    <div className="d-flex justify-content-center mb-3 mt-3 row w-100">
          <div class="align-self-center">
            <div className="d-flex justify-content-end pecas">
              <a
                href="https://emec.mec.gov.br/emec/consulta-cadastro/detalhamento/d96957f455f6405d14c6542552b0f6eb/Mjg0"
                target={"_blank"}
              >
                <img className="img-fluid" width={350} src={qrCode} alt="..." />
              </a>
            </div>
          </div>
                     <div className="align-self-end col-md-6 col-xs-12">
                <div className="d-flex justify-content-start pecas">
                  <img
              //      src={logoUnigranrioAfya}
                    alt=""
                    width={300}
                    className="img-fluid"
                  />
                </div>
        </div> 
        </div>*/}
        <p className="site-header-social">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/unigranrio"
            title="Facebook"
          >
            <i className="fab fa-facebook-f"></i>
          </a>
          {/* <a target="_blank" rel="noopener noreferrer" href="http://twitter.com/unigranrio" title="Twitter">
                                    <i className="fab fa-twitter"></i>
                                </a> */}
          {/* <a target="_blank" rel="noopener noreferrer" href="https://plus.google.com/u/0/109177974170765826768/" title="Google+">
                                    <i className="fab fa-google-plus-g"></i>
                                </a> */}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://instagram.com/unigranrio"
            title="Instagram"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.linkedin.com/company/universidade-unigranrio"
            title="LinkedIn"
          >
            <i className="fab fa-linkedin-in"></i>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.youtube.com/user/unigranrioonline"
            title="YouTube"
          >
            <i className="fab fa-youtube"></i>
          </a>
        </p>

        <small>
          {new Date().getFullYear()} © Universidade Unigranrio | Todos os
          direitos reservados | Departamento de Tecnologia da Informação
        </small>

        <p className="site-footer-links">
          <a
            target={"_blank"}
            href="https://portal.unigranrio.edu.br/politica-de-privacidade"
          >
            POLÍTICA DE PRIVACIDADE
          </a>
          {" | "}
         <>
  <a
    className="politica-cookies"
    target="_blank"
    href="https://portal.unigranrio.edu.br/politica-de-cookies"
  >
    POLÍTICA DE COOKIES
  </a>

  <style jsx>{`
 @media (max-width: 768px) {
  .politica-cookies {
    font-size: 9px;
    opacity: 0.3;
  }
}
    .politica-cookies:hover {
      color: #333;
    }
  `}</style>
</>

          {" | "}
          <a
            target={"_blank"}
            href="https://privacyportal-br.onetrust.com/webform/309bef31-1bad-4222-a8de-b66feda5e113/73b12698-ca60-4899-92f8-f02477112b54"
          >
            PEDIDO DO TITULAR DE DADOS
          </a>
        </p>
      </footer>
    );
  }
}
